import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Drop, Button, Calendar, Anchor } from 'wt-ui';

import { actions } from '../../services/reducer';

const CustomDateDrop = ({ forwardRef, closeDrop, startDate, endDate, dispatch }) => {
  const [dates, setDates] = useState([[startDate, endDate]]);

  const [date, setDate] = useState(undefined);
  const onSelect = (arg) => {
    // console.log('arg', arg);
    if (Array.isArray(arg)) {
      setDate(undefined);
      setDates(arg);
      // setShowCalendar(false);
    } else {
      setDate(arg);
    }
  };

  const RANGE_MAP = ['7 days', '14 days', '30 days'];
  const selectPredifinedRange = (range) => {
    const newEndDate = new Date();
    let newStartDate = new Date(newEndDate - 1000 * 60 * 60 * 24 * 7).toISOString();
    switch (range) {
      case '7 days':
        newStartDate = new Date(newEndDate - 1000 * 60 * 60 * 24 * 7).toISOString();
        break;
      case '14 days':
        newStartDate = new Date(newEndDate - 1000 * 60 * 60 * 24 * 14).toISOString();
        break;
      case '30 days':
        newStartDate = new Date(newEndDate - 1000 * 60 * 60 * 24 * 30).toISOString();
        break;
      default:
        break;
    }

    setDates([[newStartDate, newEndDate.toISOString()]]);
  };

  return (
    <Drop
      align={{ top: 'bottom', right: 'right' }}
      target={forwardRef.current}
      onClickOutside={closeDrop}
      onEsc={() => closeDrop()}
      pad="small"
      overflow="auto"
    >
      <Box background="transparent" style={{}} gap="medium">
        <Box background="transparent" align="center">
          <Calendar dates={dates} date={date} range daysOfWeek onSelect={onSelect} size="medium" />
        </Box>

        <Box direction="row" background="transparent" justify="between">
          <Box background="transparent" direction="row" gap="small" align="center">
            {RANGE_MAP.map((r) => (
              <Anchor
                key={r}
                onClick={() => {
                  selectPredifinedRange(r);
                }}
              >
                {r}
              </Anchor>
            ))}
          </Box>

          <Box background="transparent" direction="row" align="baseline" gap="small">
            <Anchor onClick={closeDrop}>Cancel</Anchor>
            <Button
              primary
              onClick={() => {
                dispatch({
                  type: actions.setDateFilters,
                  value: {
                    startDate: dates[0][0],
                    endDate: dates[0][1],
                  },
                });
                closeDrop();
              }}
            >
              APPLY
            </Button>
          </Box>
        </Box>
      </Box>
    </Drop>
  );
};
CustomDateDrop.defaultProps = {
  // dates: undefined,
};
CustomDateDrop.propTypes = {
  forwardRef: PropTypes.shape({
    current: PropTypes.object,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  closeDrop: PropTypes.func.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
};

export default CustomDateDrop;
